import Logo from "../../components/Logo";

import { useContext, useState } from "react";

import styles from "./styles.module.css";
import DescricaoProjeto from "./EtapasFormulario/DescricaoProjeto";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import CronogramaExecucao from "./EtapasFormulario/Execucao/CronogramaExecucao";
import CronogramaAplicacao from "./EtapasFormulario/Execucao/CronogramaAplicacao";
import RelacaoEquipamentos from "./EtapasFormulario/Equipamentos/RelacaoEquipamentos";
import { DescricaoDoProjeto } from "../../model/PlanoDeTrabalho/DescricaoDoProjeto";
import AquisicaoEquipamentos from "./EtapasFormulario/Equipamentos/AquisicaoEquipamentos";
import {
  AquisicaoForm,
  Equipamento,
} from "../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import {
  MetaAplicacaoRecurso,
  MetaCalendario,
} from "../../model/PlanoDeTrabalho/PlanoAplicacao";
import AplicacaoTab from "./EtapasFormulario/AplicacaoTab";
import CronogramaCalendario from "./EtapasFormulario/CronogramaCalendario";
import { UserContext } from "../../context/UserContext";
import registroNovoPlanoDeTrabalho from "../../services/registroNovoPlanoDeTrabalho";
import convertCalendario from "../../services/convertCalendario";
import { useLocation, useNavigate } from "react-router-dom";
import { toIsoString } from "../../controllers/Converters";

function NovoPlano() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, instituicao_id } = useContext(UserContext);
  const setPlano = (manutencao: string) => {
    setAquisicao(manutencao);
    if (descricao && aquisicao) {
      const enviarPlanoTrabalho = async () => {
        const receitasDespesas = convertCalendario(
          listaAplicacoesOrgaoReceita,
          listaAplicacoesOSCReceita,
          listaAplicacoesOrgaoDespesa,
          listaAplicacoesOSCDespesa
        );
        await registroNovoPlanoDeTrabalho(
          token,
          undefined,
          instituicao_id,
          {
            titulo_projeto: descricao.titulo,
            edital_id: descricao.edital_id,
            modalidade: descricao.modalidade,
            orgao_financiador: descricao.entidadeFinanciador,
            objeto_parceria: descricao.objetoDaParceria,
            area_atendimento: descricao.areaAtendimento,
            inicio: toIsoString(descricao.prazoDeExecucao.inicio),
            fim: toIsoString(descricao.prazoDeExecucao.fim),
            descricao_realidade: descricao.descricaoDaRealidade,
            forma_execucao: descricao.formaExecucao,
            descricao_metas: descricao.descricaoMetasQuantitativas,
            indicadores: descricao.definicaoIndicadores,
            manutencao_equipamentos: aquisicao,
          },
          listaMetas,
          [...aplicacoesCapital, ...aplicacoesCorrente],
          [
            ...listaAplicacoesManutencao,
            ...listaAplicacoesConsumo,
            ...listaAplicacoesPermanente,
            ...listaAplicacoesTerceiro,
          ],
          receitasDespesas,
          itens
        );
      };
      try {
        enviarPlanoTrabalho();
        navigate("/conta");
      } catch {
        console.log("erro ao enviar plano de trabalho");
      }
    }
  };

  const [descricao, setDescricao] = useState<DescricaoDoProjeto>();
  const [aquisicao, setAquisicao] = useState("");
  const [listaMetas, setMetasCronoFisico] = useState<MetaFisica[]>([]);
  const [aplicacoesCorrente, setAppCorrente] = useState<MetaAplicacao[]>([]);
  const [aplicacoesCapital, setAppCapital] = useState<MetaAplicacao[]>([]);
  const [listaAplicacoesManutencao, setMetasManutencao] = useState<
    MetaAplicacaoRecurso[]
  >([]);
  const [listaAplicacoesConsumo, setMetasConsumo] = useState<
    MetaAplicacaoRecurso[]
  >([]);
  const [listaAplicacoesPermanente, setMetasPermanente] = useState<
    MetaAplicacaoRecurso[]
  >([]);
  const [listaAplicacoesTerceiro, setMetasTerceiro] = useState<
    MetaAplicacaoRecurso[]
  >([]);
  const [listaAplicacoesOrgaoReceita, setAplicacoesOrgaoReceita] = useState<
    MetaCalendario[]
  >([]);
  const [listaAplicacoesOSCReceita, setAplicacoesOSCReceita] = useState<
    MetaCalendario[]
  >([]);
  const [listaAplicacoesOrgaoDespesa, setAplicacoesOrgaoDespesa] = useState<
    MetaCalendario[]
  >([]);
  const [listaAplicacoesOSCDespesa, setAplicacoesOSCDespesa] = useState<
    MetaCalendario[]
  >([]);
  const [itens, setItens] = useState<Equipamento[]>([]);

  const [tabPrincipalIndex, setPrincipalTabIndex] = useState(0);
  const passarPaginaTabPrincipal = (step: number = 1) => {
    setPrincipalTabIndex(tabPrincipalIndex + step);
  };
  const [tab2Index, set2TabIndex] = useState(0);
  const passarPaginaTab2 = (step: number = 1) => {
    set2TabIndex(tab2Index + step);
  };
  const [tab3Index, set3TabIndex] = useState(0);
  const passarPaginaTab3 = (step: number = 1) => {
    set3TabIndex(tab3Index + step);
  };
  const [tab6Index, set6TabIndex] = useState(0);
  const passarPaginaTab6 = (step: number = 1) => {
    set6TabIndex(tab6Index + step);
  };

  const [disable2Tab, setDisable2Tab] = useState(true);
  const [disable3456Tab, setDisable3456Tab] = useState(true);

  return (
    <section className={styles.cadastroPg}>
      <header>
        <Logo />
      </header>

      <main>
        <Tabs
          selectedIndex={tabPrincipalIndex}
          onSelect={(index) => setPrincipalTabIndex(index)}
        >
          <TabList>
            <Tab>1. Descrição</Tab>
            <Tab disabled={disable2Tab}>2. Cronograma de Execução</Tab>
            <Tab disabled={disable3456Tab}>3. Plano de Aplicação</Tab>
            <Tab disabled={disable3456Tab}>4. Cronograma de Receita</Tab>
            <Tab disabled={disable3456Tab}>5. Cronograma de Despesa</Tab>
            <Tab disabled={disable3456Tab}>
              6. Aquisição de Equipamentos e Materiais Permanentes
            </Tab>
          </TabList>

          <TabPanel>
            <DescricaoProjeto
              passarPagina={() => {
                passarPaginaTabPrincipal();
                setDisable2Tab(false);
              }}
              descricaoObj={descricao}
              setDescricao={setDescricao}
              refEdital={location.state || undefined}
            />
          </TabPanel>

          <TabPanel>
            <Tabs
              selectedIndex={tab2Index}
              onSelect={(index) => set2TabIndex(index)}
            >
              <TabList>
                <Tab>2.1. Cronograma de Execução Fisico</Tab>
                <Tab disabled={disable3456Tab}>
                  2.2. Cronograma de Aplicação Financeira
                </Tab>
              </TabList>
              <TabPanel>
                <form
                  className={styles.formCadastro}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <CronogramaExecucao
                    passarPagina={() => {
                      passarPaginaTab2();
                      setDisable3456Tab(false);
                    }}
                    voltarPagina={() => passarPaginaTabPrincipal(-1)}
                    listaMetas={listaMetas}
                    setMetas={setMetasCronoFisico}
                  />
                </form>
              </TabPanel>
              <TabPanel>
                <form className={styles.formCadastro}>
                  <CronogramaAplicacao
                    passarPagina={passarPaginaTabPrincipal}
                    voltarPagina={() => passarPaginaTab2(-1)}
                    aplicacoesCapital={aplicacoesCapital}
                    aplicacoesCorrente={aplicacoesCorrente}
                    setAppCapital={setAppCapital}
                    setAppCorrente={setAppCorrente}
                    listaMetas={listaMetas}
                  />
                </form>
              </TabPanel>
            </Tabs>
          </TabPanel>

          <TabPanel>
            <Tabs
              selectedIndex={tab3Index}
              onSelect={(index) => set3TabIndex(index)}
            >
              <TabList>
                <Tab>3.1. Manutenção Predial</Tab>
                <Tab>3.2. Material Permanente</Tab>
                <Tab>3.3. Material de Consumo</Tab>
                <Tab>3.4. Serviços de Terceiros (Pessoa Jurídica)</Tab>
              </TabList>
              <TabPanel>
                <form>
                  <AplicacaoTab
                    passarPagina={passarPaginaTab3}
                    voltarPagina={() => passarPaginaTabPrincipal(-1)}
                    listaAplicacoes={listaAplicacoesManutencao}
                    setMetas={setMetasManutencao}
                    title="3.1. Manutenção Predial:"
                    listaMetas={listaMetas}
                    tipo="Manutenção Predial"
                  />
                </form>
              </TabPanel>
              <TabPanel>
                <form className={styles.formCadastro}>
                  <AplicacaoTab
                    passarPagina={passarPaginaTab3}
                    voltarPagina={() => passarPaginaTab3(-1)}
                    listaAplicacoes={listaAplicacoesPermanente}
                    setMetas={setMetasPermanente}
                    title="3.2. Material Permanente:"
                    listaMetas={listaMetas}
                    tipo="Material Permanente"
                  />
                </form>
              </TabPanel>
              <TabPanel>
                <form>
                  <AplicacaoTab
                    passarPagina={passarPaginaTab3}
                    voltarPagina={() => passarPaginaTab3(-1)}
                    listaAplicacoes={listaAplicacoesConsumo}
                    setMetas={setMetasConsumo}
                    title="3.3. Material de Consumo:"
                    listaMetas={listaMetas}
                    tipo="Material de Consumo"
                  />
                </form>
              </TabPanel>
              <TabPanel>
                <form>
                  <AplicacaoTab
                    passarPagina={passarPaginaTabPrincipal}
                    voltarPagina={() => passarPaginaTab3(-1)}
                    listaAplicacoes={listaAplicacoesTerceiro}
                    setMetas={setMetasTerceiro}
                    title="3.4. Serviços de Terceiros (Pessoa Jurídica)"
                    listaMetas={listaMetas}
                    tipo="Serviços de Terceiros"
                  />
                </form>
              </TabPanel>
            </Tabs>
          </TabPanel>

          <TabPanel>
            <form>
              <CronogramaCalendario
                passarPagina={passarPaginaTabPrincipal}
                voltarPagina={() => passarPaginaTabPrincipal(-1)}
                listaAplicacoesOSC={listaAplicacoesOSCReceita}
                setAplicacoesOSC={setAplicacoesOSCReceita}
                listaAplicacoesOrgao={listaAplicacoesOrgaoReceita}
                setAplicacoesOrgao={setAplicacoesOrgaoReceita}
                listaMetas={listaMetas}
                title={
                  <>
                    4. Cronograma de <strong>Receita</strong> :
                  </>
                }
              />
            </form>
          </TabPanel>

          <TabPanel>
            <form>
              <CronogramaCalendario
                passarPagina={passarPaginaTabPrincipal}
                voltarPagina={() => passarPaginaTabPrincipal(-1)}
                listaAplicacoesOSC={listaAplicacoesOSCDespesa}
                setAplicacoesOSC={setAplicacoesOSCDespesa}
                listaAplicacoesOrgao={listaAplicacoesOrgaoDespesa}
                setAplicacoesOrgao={setAplicacoesOrgaoDespesa}
                listaMetas={listaMetas}
                title={
                  <>
                    5. Cronograma de <strong>Despesa</strong> :
                  </>
                }
              />
            </form>
          </TabPanel>

          <TabPanel>
            <Tabs
              selectedIndex={tab6Index}
              onSelect={(index) => set6TabIndex(index)}
            >
              <TabList>
                <Tab>6.1. Relação dos Equipamentos e Materiais Permanentes</Tab>
                <Tab>6.2. Manutenção Preventiva</Tab>
              </TabList>
              <TabPanel>
                <form onSubmit={(e) => e.preventDefault()}>
                  <RelacaoEquipamentos
                    passarPagina={passarPaginaTab6}
                    voltarPagina={() => passarPaginaTabPrincipal(-1)}
                    itens={itens}
                    setItens={setItens}
                    listaMetas={listaMetas}
                  />
                </form>
              </TabPanel>
              <TabPanel>
                <form>
                  <AquisicaoEquipamentos
                    voltarPagina={() => passarPaginaTab6(-1)}
                    aquisicaoObj={aquisicao}
                    setAquisicao={setAquisicao}
                    finalizar={setPlano}
                  />
                </form>
              </TabPanel>
            </Tabs>
          </TabPanel>
        </Tabs>
      </main>
    </section>
  );
}

export default NovoPlano;
